import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18b1fe5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page flex-down-center" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "heading" }, "Enter your phone number", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "txt" }, "You will receive an SMS with your new password", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "phone number", -1))
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "errors-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicSpinner = _resolveComponent("BasicSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "login-form",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.forgot && _ctx.forgot(...args)), ["prevent"]))
      }, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "tel",
          name: "phone",
          class: "email-in in",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phone) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.phone]
        ]),
        (_ctx.hasClicked)
          ? (_openBlock(), _createBlock(_component_BasicSpinner, {
              key: 0,
              class: "loader"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "submit",
          class: "submit-btn",
          disabled: _ctx.hasClicked
        }, "Reset password", 8, _hoisted_6),
        (_ctx.errors.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                return (_openBlock(), _createElementBlock("h6", {
                  class: "error",
                  key: error
                }, _toDisplayString(error), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ])
  ]))
}